import styled from 'styled-components';

import { Container } from '../container';


export const MainStyle = styled(Container)`
  position: relative;
  margin-top: ${({ theme }) => theme.space[1]};
  margin-bottom: ${({ theme }) => theme.space[1]};
`;
